module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento8.64378f15.svg";